import InPlayWidget from './in_play_widget';

export default InPlayWidget;
